import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";

import Loading from "../../../components/Loading";

import api from "../../../services/api";

const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

export default function PCP() {
    const [articles, setArticles] = useState([]);
    const [articlesSelected, setArticlesSelected] = useState([]);
    const [data, setData] = useState([]);
    const [months, setMonths] = useState([]);
    const [monthsF, setMonthsF] = useState([]);
    const [search, setSearch] = useState("");
    const [searchFamilia, setSearchFamilia] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const content = useRef();

    const column = {
        border: '1px solid black',
        color: "#000",
        padding: 4,
        textAlign: "center",
        width: (100 / (15 + months.length)) + "%"
    };

    function getClassName(rowData) {
        let percentage = parseFloat(rowData.porcentagem);
        if(percentage < 30) {
            return "";
        } else if(percentage >= 30 && percentage < 50) {
            return "pcp-line-green";
        } else if(percentage >= 50 && percentage < 90) {
            return "pcp-line-yellow";
        } else {
            return "pcp-line-red";
        }
    }

    function formatMonth(month, type = null) {
        let num;
        if(type === null)
            num = String(month).replace('mes', '');
        else
            num = String(month).replace('mesforro', '');

        let monthf = meses[num - 1];
        return "" + monthf;
    }

    function formatNumber(rowData, props) {
        if(rowData[props.field] > 0) {
            return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData[props.field]);
        } else {
            return 0;
        }
    }

    const handlePrint = useReactToPrint({
        content: () => content.current
    });

    useEffect(() => {
        setIsLoading(true);
        api.get("pcp").then((response) => {
            const { dados, meses, meses_forro } = response.data;
            setData(dados);
            setMonths(meses);
            setMonthsF(meses_forro);

            let _articles = [];
            dados.forEach((element) => {
                _articles.push({
                    "label": element.artigo,
                    "value": element.artigo
                });
            });

            _articles = _articles.sort((a, b) => {
                return a.label - b.label;
            })

            setArticles(_articles);
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }, []);

    if(isLoading) {
        return <Loading />
    }

    const filteredData = data.filter((element) => {
        let isValid = true;

        if (search.length > 0) {
            isValid = isValid && String(element.artigo).includes(search);
        }

        if (searchFamilia.length > 0) {
            isValid = isValid && element.familia && String(element.familia).toLowerCase() === searchFamilia.toLowerCase();
        }

        if (articlesSelected.length > 0) {
            isValid = isValid && articlesSelected.includes(element.artigo);
        }

        return isValid;
    });

    return (
        <div>
            <div className="p-d-flex p-flex-row p-jc-between">
                <div>
                    <Button
                        className="p-m-1"
                        icon="pi pi-print"
                        onClick={handlePrint}
                    />

                    <InputText
                        className="p-m-1"
                        onChange={e => setSearch(e.target.value)}
                        placeholder="Artigo: 455"
                        value={search}
                    />

                    <InputText
                        className="p-m-1"
                        onChange={e => setSearchFamilia(e.target.value)}
                        placeholder="Família: 1"
                        value={searchFamilia}
                    />
                </div>
                <MultiSelect
                    filter
                    onChange={e => setArticlesSelected(e.value)}
                    maxSelectedLabels={3}
                    options={articles}
                    optionLabel="label"
                    optionValue="value"
                    value={articlesSelected}
                />
            </div>

            <div className="tabela-copiavel">
                <DataTable
                    className="p-m-1"
                    emptyMessage="Nenhum artigo encontrado."
                    ref={content}
                    responsiveLayout="scroll"
                    rowClassName={getClassName}
                    size="small"
                    style={{ fontSize: 13 }}
                    value={filteredData}
                >
                    <Column alignHeader="center" header="Artigo" field="artigo" style={column} sortable />
                    <Column alignHeader="center" header="Nº Teares" field="tear_qtde" style={column} sortable />
                    <Column alignHeader="center" header="Família" field="familia" style={column} body={rowData => rowData.familia || '-'} sortable />
                    <Column alignHeader="center" header="1º" field="class1" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="1º SR" field="class1semrestricao" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="1º CR" field="class1comrestricao" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="2º" field="class2" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="3º" field="class3" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="4º" field="class4" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Acabamento" field="acabamento" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Acabado" field="acabado" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Revisão" field="revisao" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Revisado" field="revisado" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Tecelagem" field="tecelagem" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Estoque Tear" field="tear_estoque" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Estoque Total" field="total" body={formatNumber} bodyStyle={{ fontWeight: "bold" }} style={column} sortable />
                    <Column alignHeader="center" header="Total Vendas/Cortes" field="totalv" body={formatNumber} bodyStyle={{ fontWeight: "bold" }} style={column} sortable />
                    <Column alignHeader="center" header="Vendas" field="pedidos" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Cortes" field="cortes" body={formatNumber} style={column} sortable />
                    <Column alignHeader="center" header="Forros" field="forros" body={formatNumber} style={column} sortable />
                    {months.map((month, index) => (
                        <Column
                            alignHeader="center"
                            field={month}
                            key={`mes${index}`}
                            header={() => formatMonth(month)}
                            sortable
                            style={column}
                            body={(rowData) => {
                                if(rowData[month] !== undefined && rowData[month] > 0) {
                                    return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData[month]);
                                } else {
                                    return 0;
                                }
                            }}
                        />
                    ))}
                    {monthsF.map((month, index) => (
                        <Column
                            alignHeader="center"
                            field={month}
                            key={`mes${index}`}
                            header={() => formatMonth(month, 1) + ' F'}
                            sortable
                            style={column}
                            body={(rowData) => {
                                if(rowData[`${month}`] !== undefined && rowData[month] > 0) {
                                    return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData[month]);
                                } else {
                                    return 0;
                                }
                            }}
                        />
                    ))}

                    <Column alignHeader="center" header="% Vendas" field="porcentagem" body={(rowData) => {
                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData.porcentagem) + "%"
                    }} sortable style={column} />
                </DataTable>
            </div>
        </div>
    )
}
